import React from 'react';
import cx from 'classnames';
import PropTypes from 'prop-types';
import { Form as FinalForm, FormSpy, Field } from 'react-final-form';

// components
import { ButtonV2 } from '@zola/zola-ui';

// form components
import MeetingTimeFormFieldSet from 'components/manage/VirtualEvents/MeetingTimeFormFieldSet';
import {
  renderEventTypeField,
  renderEventTitleField,
} from 'components/manage/VirtualEvents/common/FormFields/FormFields';

import css from './CreateZoomEventForm.module.less';
import './CreateZoomEventForm.less'; // For ZUI overrides

// TODO: add component tests

const CreateZoomEventForm = ({ initialValues, onSubmit, handleSaveFormState }) => {
  return (
    <FinalForm
      initialValues={initialValues}
      onSubmit={onSubmit}
      // debug={console.log}
      render={formProps => (
        <form
          className={cx(css.container, 'createZoomeEventForm', 'margin-bottom')}
          onSubmit={formProps.handleSubmit}
        >
          <Field name="eventId" disabled render={() => null} />
          <div className={css.eventFields}>
            {renderEventTitleField(css.marginRight)}
            {renderEventTypeField()}
          </div>
          <MeetingTimeFormFieldSet />
          <ButtonV2 type="submit" className={css.button}>
            Save Event Details
          </ButtonV2>
          <FormSpy
            subscription={{ values: true }}
            onChange={formState => {
              if (typeof handleSaveFormState === 'function') {
                handleSaveFormState(formState.values);
              }
            }}
          />
        </form>
      )}
    />
  );
};

CreateZoomEventForm.propTypes = {
  initialValues: PropTypes.shape({}),
  onSubmit: PropTypes.func,
};

CreateZoomEventForm.defaultProps = {};

export default CreateZoomEventForm;



// WEBPACK FOOTER //
// ./src/components/manage/VirtualEvents/CreateZoomEventForm/CreateZoomEventForm.jsx